<div class="video-chat-message" *ngIf="isVisible && !hasEnded" [@videoChatStatusBubbleAnimation]>
  <div class="chat-message">
    <div class="chat-message-text">
      <span [innerHTML]="bubbleStatus | translate:translateParams"></span>
      <span *ngIf="counter">({{ counter }})</span>
      <button *ngIf="showJoinButton" (click)="actionButtonClicked()">
        <svg-icon icon="call"></svg-icon>
        <span>{{ buttonText | translate }}</span>
      </button>
    </div>
  </div>
</div>